/*
 * Vangnet voor de GPO-app ("Globo Options"): wanneer de app zelf de submit
 * afhandelt (bv. om eerst verplichte opties te valideren), gaat dat buiten
 * onze eigen <product-form>-AJAX-afhandeling om, waardoor de sidecart
 * (cart-notification) niet ververst/opent — alleen een handmatige paginarefresh
 * toonde de toegevoegde producten. De app doet wel een echte AJAX-call naar
 * cart/add(.js) (geen page-navigatie), dus we onderscheppen window.fetch zelf
 * en reageren zodra zo'n call succesvol teruggkomt, ongeacht wie 'm deed.
 */
(function () {
  function refreshAndOpenCart() {
    var cartNotification = document.querySelector('cart-notification');
    if (!cartNotification) return;

    fetch(window.location.pathname + '?section_id=form-mini-cart', { cache: 'no-store' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#form-mini-cart');
        var current = document.getElementById('form-mini-cart');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        cartNotification.open();
        if (window.BlsLazyloadImg && typeof window.BlsLazyloadImg.init === 'function') {
          window.BlsLazyloadImg.init();
        }
      })
      .catch(function () {});

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.innerHTML = cart.item_count;
        });
      })
      .catch(function () {});
  }

  if (window.__gpoCartSyncPatched) return;
  window.__gpoCartSyncPatched = true;

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var promise = originalFetch.apply(this, arguments);
    if (isCartAdd) {
      promise.then(function (response) {
        if (response && response.ok) {
          setTimeout(refreshAndOpenCart, 50);
        }
      }).catch(function () {});
    }
    return promise;
  };
})();
